var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYandexPaymethod = function SvgYandexPaymethod(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#7B61FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z",
    fill: "#7B61FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.725 16.1143H13.2828V8.96533H12.6388C11.4596 8.96533 10.8428 9.55577 10.8428 10.4369C10.8428 11.4361 11.2691 11.8994 12.149 12.4898L12.8746 12.9804L10.7884 16.1143H9.23732L11.1149 13.3165C10.0355 12.5443 9.4278 11.7904 9.4278 10.5187C9.4278 8.92899 10.5344 7.84802 12.6297 7.84802H14.7159V16.1143H14.725Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "#7B61FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYandexPaymethod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "yandex-pay.method.e33ed46734e1e2174352261aa9715bf0.svg";